/**
 * AskOrellaChip v179.1.3
 * 
 * "Ask Orella" CTA pill with pulse animation.
 * 
 * variant='default' — ice blue bg, light blue border (standalone on white backgrounds)
 * variant='navy'    — solid navy bg, white text (CTA inside ice-blue speech bubbles)
 */

const CHIP_KEYFRAMES = `
@keyframes orellaChipPulse {
  0%, 100% { box-shadow: 0 2px 8px rgba(70,168,249,0.15); }
  50% { box-shadow: 0 2px 16px rgba(70,168,249,0.3); }
}
@keyframes orellaChipPulseNavy {
  0%, 100% { box-shadow: 0 3px 10px rgba(21,53,79,0.15); }
  50% { box-shadow: 0 3px 20px rgba(21,53,79,0.3); }
}
`

const VARIANTS = {
  default: {
    bg: '#E9F8FF',
    border: '1.5px solid #A7D9FC',
    color: '#15354F',
    iconStroke: '#46A8F9',
    pulse: 'orellaChipPulse 3s ease-in-out infinite',
  },
  navy: {
    bg: '#15354F',
    border: '1.5px solid #15354F',
    color: '#FFFFFF',
    iconStroke: '#FFFFFF',
    pulse: 'orellaChipPulseNavy 2.5s ease-in-out infinite',
  },
  outline: {
    bg: '#FFFFFF',
    border: '1.5px solid #15354F',
    color: '#15354F',
    iconStroke: '#15354F',
    pulse: 'orellaChipPulseNavy 2.5s ease-in-out infinite',
  },
  // v229.1.0: White-fill variant — white bg, light-blue border, blue icon,
  // navy text. Used inline in the focus-page Orella dialogue (replaces the
  // floating FAB). Same box-shadow pulse as the default variant (NO shimmer).
  white: {
    bg: '#FFFFFF',
    border: '1.5px solid #A7D9FC',
    color: '#15354F',
    iconStroke: '#46A8F9',
    pulse: 'orellaChipPulse 3s ease-in-out infinite',
  },
}

export default function AskOrellaChip({ onClick, label = 'Ask Orella', variant = 'default', style = {} }) {
  const v = VARIANTS[variant] || VARIANTS.default

  return (
    <>
      <style>{CHIP_KEYFRAMES}</style>
      <button
        onClick={onClick}
        className="relative overflow-hidden inline-flex items-center gap-2 rounded-full active:scale-[0.96] transition-transform"
        style={{
          padding: '8px 16px',
          fontSize: '13px',
          fontWeight: 600,
          color: v.color,
          background: v.bg,
          border: v.border,
          animation: v.pulse,
          ...style,
        }}
      >
        {/* Icon */}
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={v.iconStroke} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ transform: 'scaleX(-1)' }}>
          <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" />
        </svg>
        <span>{label}</span>
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={v.iconStroke} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="9 18 15 12 9 6" />
        </svg>
      </button>
    </>
  )
}
